import { createPersonsInputHelper } from "@/components/ReservationSidebar/helpers/createPersonsInputHelper.ts";
import { CartAccommodationInput, ParcelObjectsInput, ParcelObjectType } from "@/helpers/types/types.ts";
import { findRatePlanIdPerOccupancy } from "@/pages/ReservationOverview/findRatePlanIdPerOccupancy.ts";
import { CartAccommodationItem } from "@/stores/EngineStore/interfaces/CartAccommodationItem.ts";
import format from "date-fns/format";

export const getCartAccommodationInput = (
  cartAccommodationItems: CartAccommodationItem[],
): CartAccommodationInput[] => {
  const accommodations: CartAccommodationInput[] = [];

  cartAccommodationItems.forEach((CAI) => {
    if (!CAI.dateRange[0] || !CAI.dateRange[1]) return;
    const persons = createPersonsInputHelper(CAI.adults, CAI.children);
    const ratePlanId = findRatePlanIdPerOccupancy(CAI.ratePlan, persons.length);

    const extras = CAI.optionalExtras?.map((o) => ({ extraId: o.id, quantity: o.value })) || [];
    let parcelObjects: ParcelObjectsInput | undefined;

    if (CAI.parcelObjectType || CAI.rateGroup?.isParcel) {
      parcelObjects = {
        dimensions: CAI.parcelObjectDimensions || "",
        tentDimensions: CAI.parcelObjectAdditionalTentDimensions || "",
        type: CAI.parcelObjectType || ParcelObjectType.Camper,
      };
    }

    accommodations.push({
      checkIn: format(new Date(CAI.dateRange[0]), "yyyy-MM-dd"),
      checkOut: format(new Date(CAI.dateRange[1]), "yyyy-MM-dd"),
      extras,
      persons,
      ratePlanId,
      parcelObjects,
    });
  });

  return accommodations;
};
